import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/index'
import LegacyMenu from '@/page/legacyMenu'
import Profile from '@/page/profile'
import PersonalInfo from '@/page/personalInfo'
import Referral from '@/page/referral'
import WinnerList from '@/page/winnerList'
import TrafficReward from '@/page/trafficReward'
import LuckyDraw from '@/page/luckyDraw'
import Language from '@/page/language'
import Faq from '@/page/faq'
import Faq2 from '@/page/faq2'
import MyAccount from '@/page/myAccount'
import TermsAndCondition from '@/page/termsAndCondition'
import TermsAndCondition2 from '@/page/termsAndCondition2'
import TC from '@/page/TC'
import Subscribe_v2 from '@/page/login'
import Login from '@/page/login'
import OtpLogin from '@/page/otpLogin'
import Subscribe from '@/page/subscribe'
import Errors from '@/page/errors'

Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    if (to.path === '/') return {x: 0, y: 0}
    return savedPosition || undefined
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        title: ''
      }
    },
    {
      path: '/Subscribe_v2',
      name: 'login',
      component: Subscribe_v2,
      meta: {
        title: 'login'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Subscribe_v2,
      meta: {
        title: 'login'
      }
    },
    {
      path: '/otpLogin',
      name: 'otpLogin',
      component: OtpLogin,
      meta: {
        title: 'otpLogin'
      }
    },
    {
      path: '/subscribe',
      name: 'subscribe',
      component: Subscribe,
      meta: {
        title: 'subscribe'
      }
    },
    {
      path: '/menu',
      name: 'menu',
      component: LegacyMenu,
      meta: {
        title: ''
      }
    }, {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        title: 'Profile'
      }
    }, {
      path: '/personalInfo',
      name: 'personalInfo',
      component: PersonalInfo,
      meta: {
        title: ''
      }
    }, {
      path: '/myAccount',
      name: 'myAccount',
      component: MyAccount,
      meta: {
        title: ''
      }
    }, {
      path: '/faq',
      name: 'faq',
      component: Faq,
      meta: {
        title: 'faqs'
      }
    }, {
      path: '/faq2',
      name: 'faq',
      component: Faq2,
      meta: {
        title: 'faqs2'
      }
    }, {
      path: '/TC',
      name: 'TC',
      component: TC,
      meta: {
        title: 'Terms and Condition'
      }
    }, {
      path: '/termsAndCondition',
      name: 'termsAndCondition',
      component: TermsAndCondition,
      meta: {
        title: 'Terms and Condition'
      }
    }, {
      path: '/termsAndCondition2',
      name: 'termsAndCondition',
      component: TermsAndCondition2,
      meta: {
        title: 'Terms and Condition'
      }
    },

    {
      path: '/referral',
      name: 'referral',
      component: Referral,
      meta: {
        title: 'referral'
      }
    }, {
      path: '/winnerList',
      name: 'winnerList',
      component: WinnerList,
      meta: {
        title: 'winnerList'
      }
    }, {
      path: '/trafficReward',
      name: 'trafficReward',
      component: TrafficReward,
      meta: {
        title: 'trafficReward'
      }
    }, {
      path: '/luckyDraw',
      name: 'luckyDraw',
      component: LuckyDraw,
      meta: {
        title: 'luckyDraw'
      }
    }, {
      path: '/language',
      name: 'language',
      component: Language,
      meta: {
        title: 'language'
      }
    },

    {
      path: '/errors',
      name: 'errors',
      component: Errors,
      meta: {
        title: 'errors'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js